import { apiClient, getErrorMessage } from './apiClient'
import type { PaginationResponse } from './clienteService'

export interface Notificacao {
  id: string
  userId: string
  tipo: 'pedido_criado' | 'pedido_atualizado' | 'status_alterado' | 'sistema'
  titulo: string
  mensagem: string
  pedidoId?: string
  lida: boolean
  createdAt: string
}

export interface NotificacaoFilters {
  page?: number
  limit?: number
  lida?: 'true' | 'false' | 'all'
}

export interface NotificacaoResponse extends PaginationResponse<Notificacao> {
  naoLidas: number
}

export const notificacaoService = {
  async getAll(filters?: NotificacaoFilters): Promise<NotificacaoResponse> {
    try {
      const params = new URLSearchParams()
      if (filters?.page) params.append('page', filters.page.toString())
      if (filters?.limit) params.append('limit', filters.limit.toString())
      if (filters?.lida && filters.lida !== 'all') params.append('lida', filters.lida)

      const response = await apiClient.get<NotificacaoResponse>(`/notificacoes?${params}`)
      return response.data
    } catch (error) {
      throw new Error(getErrorMessage(error))
    }
  },

  async marcarComoLida(id: string): Promise<Notificacao> {
    try {
      const response = await apiClient.patch<Notificacao>(`/notificacoes/${id}/lida`)
      return response.data
    } catch (error) {
      throw new Error(getErrorMessage(error))
    }
  },

  async marcarTodasLidas(): Promise<{ message: string; count: number }> {
    try {
      const response = await apiClient.patch<{ message: string; count: number }>(
        '/notificacoes/marcar-todas-lidas'
      )
      return response.data
    } catch (error) {
      throw new Error(getErrorMessage(error))
    }
  },
}
